import request from '@/utils/request'

export function addUseraddress(data) {
  return request({
    url: '/mall/ordermanage/useraddress/addUseraddress',
    method: 'post',
    data
  })
}
export function queryArea(params) {
  return request({
    url: '/mall/ordermanage/useraddress/queryArea',
    method: 'post',
    params
  })
}
export function page(params) {
  return request({
    url: '/mall/ordermanage/useraddress/page',
    method: 'post',
    params
  })
}
export function queryUseraddress(params) {
  return request({
    url: '/mall/ordermanage/useraddress/queryUseraddress',
    method: 'post',
    params
  })
}
export function updateDefault(params) {
  return request({
    url: '/mall/ordermanage/useraddress/updateDefault',
    method: 'post',
    params
  })
}
export function updateUseraddress(data) {
  return request({
    url: '/mall/ordermanage/useraddress/updateUseraddress',
    method: 'post',
    data
  })
}
export function deleteUseraddress(params) {
  return request({
    url: '/mall/ordermanage/useraddress/deleteUseraddress',
    method: 'post',
    params
  })
}
